// eslint-disable-next-line import/no-extraneous-dependencies
import baguetteBox from 'baguettebox.js';

const galleryEl = document.getElementById('w-gallery');

if (galleryEl) {
  baguetteBox.run('.gallery-grid');
}
